import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ErrorHandlingService } from '../../../services/error-handling/error-handling.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SpinnerService } from '../../../services/spinner';
import { Observable, of } from 'rxjs';
import { HttpHeaderConstants } from '../../../services/http-header.constant';
import { catchError, finalize } from 'rxjs/operators';
import { AlertRequest } from '../../../models/appcloud/alert/alert-request.model';
import { AlertResponse } from '../../../models/appcloud/alert/alert-response.model';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private ALERT_URL: string = environment.publicApiHost + '/appcloud/alerts';

    manage(alertRequest: AlertRequest, additionalHeaders: any = {}): Observable<AlertResponse> {
        this.#spinnerService.addProcess('AlertService.manage', 'Managing alert...');
        const httpOptions = {
            headers: new HttpHeaders({
                ...HttpHeaderConstants.defaultHeaders,
                ...additionalHeaders,
            }),
        };

        return this.#http.post<AlertResponse>(this.ALERT_URL, alertRequest, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while managing your alert. Please try again later.'
                );
                return of<AlertResponse>();
            }),
            finalize(() => {
                this.#spinnerService.completeProcess('AlertService.manage');
            })
        );
    }
}
